import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../style.css';
import '../nov.css';

const MusicPublishing = () => {
  const logos = [
    { name: 'Sony Music', src: 'https://cdn.bcms.app/uploads/RNB_22_sony_logo_3591a185ee.png', bg: 'black' },
    { name: 'ASCAP', src: 'https://www.ascap.com/~/media/images/logos/ascap-logos/2015/hires/ascap_logo_primary_white.png', bg: 'white' },
    { name: 'Amazon Music', src: 'https://e4y4db.n3cdn1.secureserver.net/wp-content/uploads/2024/09/Amazonmusic.png', bg: 'black' },
    { name: 'YouTube Music', src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3vRi_dQM1oZOU8lYAC-r7W7bAVnN6LXeXUw&s', bg: 'white' },
    { name: 'Spotify', src: '/Spotify.png', bg: 'black' },
    { name: 'BMG', src: 'https://cdn.worldvectorlogo.com/logos/bmg-1.svg', bg: 'white' },
    { name: 'PRS for Music', src: 'https://upload.wikimedia.org/wikipedia/en/thumb/d/de/PRS_for_Music_logo.svg/1200px-PRS_for_Music_logo.svg.png', bg: 'black' },
    { name: 'Apple Music', src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSByQTADg7wf3fnu04fwKjLt96-QFGUivnZaA&s', bg: 'white' }
  ];

  return (
    <>
      <section className="min-h-screen bg-[#f5f5f7] py-32 lg:py-48 relative overflow-hidden">
        <div className="container mx-auto px-6 lg:px-16 max-w-[1400px] relative z-10">
          <div className="w-full flex flex-col lg:flex-row items-center lg:items-start justify-between gap-16 lg:gap-24">
            
            {/* Sol Taraf - Metin */}
            <div className="lg:w-5/12 text-center lg:text-left space-y-10">
              <motion.div 
                className="inline-block"
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <span 
                  className="text-xs font-medium badge-gradient text-gray-700 py-2.5 px-5 rounded-full inline-block uppercase tracking-wide" 
                  style={{ fontFamily: 'aesthet-nova' }}
                >
                  Music Publishing
                </span>
              </motion.div>

              <motion.h1 
                className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] tracking-tight uppercase"
                style={{ fontFamily: 'aesthet-nova' }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                <span style={{ color: 'rgb(70, 52, 135)' }}>
                  UNLOCK YOUR
                </span>
                <br/>
                <span 
                  style={{ '--shimmer-width': '250px' }} 
                  className="text-neutral-600/50 animate-shimmer bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shimmer-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite] bg-gradient-to-r from-neutral-100 via-black/80 via-50% to-neutral-100"
                >
                  MUSIC'S FULL
                </span>
                <br/>
                <span style={{ color: 'rgb(70, 52, 135)' }}>
                  POTENTIAL
                </span>
              </motion.h1>

              <motion.p 
                className="text-lg leading-relaxed text-gray-600"
                style={{ fontFamily: 'aesthet-nova' }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                With Media Nov's Music Publishing services, you can take control of your copyrights and maximize your earnings. We handle the complexities of royalty collection, licensing, and global distribution so you can focus on creating.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                <Link 
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-black font-semibold rounded-full hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  Learn More
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ml-2">
                    <path d="m9 18 6-6-6-6"></path>
                  </svg>
                </Link>
              </motion.div>
            </div>

            {/* Sağ Taraf - Horizontal Marquee */}
            <motion.div 
              className="lg:w-7/12 relative"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <div className="relative flex items-center justify-center overflow-hidden h-auto py-8 px-6">
                
                {/* Desktop - 4 Satır Yatay */}
                <div className="hidden lg:flex flex-col w-full gap-3">
                  {/* Satır 1 - Sağa */}
                  <div className="flex w-full overflow-hidden">
                    <div className="flex flex-row gap-3 animate-marquee">
                      {[...logos, ...logos, ...logos].map((logo, index) => (
                        <motion.div 
                          key={`row1-${index}`}
                          className="relative w-16 h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 rounded-2xl flex items-center justify-center shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm bg-white flex-shrink-0"
                          whileHover={{ 
                            y: -8,
                            scale: 1.05,
                            transition: { duration: 0.3, type: "spring", stiffness: 300 }
                          }}
                        >
                          <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                          <img 
                            alt={`${logo.name} Logo`}
                            className="h-8 lg:h-10 xl:h-12 w-auto object-contain relative z-10 max-w-[65%] max-h-[65%]"
                            src={logo.src}
                          />
                        </motion.div>
                      ))}
                    </div>
                  </div>

                  {/* Satır 2 - Sola */}
                  <div className="flex w-full overflow-hidden">
                    <div className="flex flex-row gap-3 animate-marquee-reverse">
                      {[...logos, ...logos, ...logos].map((logo, index) => (
                        <motion.div 
                          key={`row2-${index}`}
                          className="relative w-16 h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 rounded-2xl flex items-center justify-center shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm bg-white flex-shrink-0"
                          whileHover={{ 
                            y: -8,
                            scale: 1.05,
                            transition: { duration: 0.3, type: "spring", stiffness: 300 }
                          }}
                        >
                          <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                          <img 
                            alt={`${logo.name} Logo`}
                            className="h-8 lg:h-10 xl:h-12 w-auto object-contain relative z-10 max-w-[65%] max-h-[65%]"
                            src={logo.src}
                          />
                        </motion.div>
                      ))}
                    </div>
                  </div>

                  {/* Satır 3 - Sağa */}
                  <div className="flex w-full overflow-hidden">
                    <div className="flex flex-row gap-3 animate-marquee">
                      {[...logos, ...logos, ...logos].map((logo, index) => (
                        <motion.div 
                          key={`row3-${index}`}
                          className="relative w-16 h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 rounded-2xl flex items-center justify-center shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm bg-white flex-shrink-0"
                          whileHover={{ 
                            y: -8,
                            scale: 1.05,
                            transition: { duration: 0.3, type: "spring", stiffness: 300 }
                          }}
                        >
                          <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                          <img 
                            alt={`${logo.name} Logo`}
                            className="h-8 lg:h-10 xl:h-12 w-auto object-contain relative z-10 max-w-[65%] max-h-[65%]"
                            src={logo.src}
                          />
                        </motion.div>
                      ))}
                    </div>
                  </div>

                  {/* Satır 4 - Sola */}
                  <div className="flex w-full overflow-hidden">
                    <div className="flex flex-row gap-3 animate-marquee-reverse">
                      {[...logos, ...logos, ...logos].map((logo, index) => (
                        <motion.div 
                          key={`row4-${index}`}
                          className="relative w-16 h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 rounded-2xl flex items-center justify-center shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm bg-white flex-shrink-0"
                          whileHover={{ 
                            y: -8,
                            scale: 1.05,
                            transition: { duration: 0.3, type: "spring", stiffness: 300 }
                          }}
                        >
                          <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                          <img 
                            alt={`${logo.name} Logo`}
                            className="h-8 lg:h-10 xl:h-12 w-auto object-contain relative z-10 max-w-[65%] max-h-[65%]"
                            src={logo.src}
                          />
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Mobile - Yatay Marquee */}
                <div className="flex lg:hidden w-full">
                  <div className="flex w-full overflow-hidden">
                    <div className="flex flex-row gap-3 animate-marquee">
                      {[...logos, ...logos, ...logos].map((logo, index) => (
                        <motion.div 
                          key={`mobile-${index}`}
                          className="relative w-20 h-20 rounded-2xl flex items-center justify-center shadow-[inset_0_-8px_10px_#8fdfff1f] backdrop-blur-sm bg-white flex-shrink-0"
                          whileHover={{ 
                            y: -8,
                            scale: 1.05,
                            transition: { duration: 0.3, type: "spring", stiffness: 300 }
                          }}
                        >
                          <div className="absolute inset-0 block h-full w-full animate-gradient bg-gradient-to-r from-[#ffaa40]/50 via-[#9c40ff]/50 to-[#ffaa40]/50 bg-[length:300%_100%] p-[1px] ![mask-composite:subtract] [border-radius:inherit] [mask:linear-gradient(#fff_0_0)_content-box,linear-gradient(#fff_0_0)]"></div>
                          <img 
                            alt={`${logo.name} Logo`}
                            className="h-10 w-auto object-contain relative z-10 max-w-[65%] max-h-[65%]"
                            src={logo.src}
                          />
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </div>

              </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default MusicPublishing;
